import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import { Button, CircularProgress } from '@mui/material';
import { status } from 'adminConstants/investorReporting';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  disclosure: Disclosure;
  reportStatus: string;
  onConfirmPublishUpdate: () => void;
  submitting: boolean;
  notifyInvestors: boolean;
};

const PublishConfirmationDialog: FC<Props> = ({
  disclosure,
  reportStatus,
  onConfirmPublishUpdate,
  submitting,
  notifyInvestors,
}) => {
  return (
    <AlertDialog
      open={disclosure.isOpen}
      onClose={disclosure.onClose}
      title="Are you sure?"
      content={
        <p>
          Proceeding will publish this{' '}
          {reportStatus === status.SUBMITTED ? 'updated ' : ''}report to all
          investors.{' '}
          {notifyInvestors
            ? "They will receive an email notifying them of the report's release."
            : 'They will not be notified by email.'}
        </p>
      }
      btnLabels={{
        cancel: 'Go back',
        confirm: 'Confirm',
      }}
      confirmBtnComponent={
        <>
          {submitting && <CircularProgress size={20} />}
          <Button
            variant="contained"
            color="primary"
            disabled={submitting}
            type="button"
            name="proceed"
            onClick={onConfirmPublishUpdate}
          >
            Proceed
          </Button>
        </>
      }
    />
  );
};

export default PublishConfirmationDialog;
